/* eslint-disable */
import {
  getContracts,
  getContract,
  createContract,
  updateContract,
  deleteContract,
} from '@/methods/contract';
import { ElNotification } from 'element-plus';
import { getDenyPrivilegeObject, getErrorMessage } from '@/compositions/helpers/helpers';

// Дедуп одновременных запросов списка: блок ЭТРН и постоянно смонтированные
// *FormDialog дергают getContracts в один тик — схлопываем их в один HTTP-запрос.
// Ключ — partnerId (или 'all' без фильтра): фильтрованный и полный список
// не должны схлопываться в один запрос.
const contractsInFlight = new Map();

// Список в сторе один на всё приложение, а запросы с разным фильтром летят параллельно.
// Отвечают они в произвольном порядке, поэтому применяем только ответ на последний
// запрошенный фильтр — иначе полный список затирает отфильтрованный.
let contractsLatestKey = null;

const contractDetailsInFlight = new Map();

const state = {
  list: [],
  dataIsUpdated: false,
};

const getters = {
  getContracts(state) {
    return state.list;
  },
};

const mutations = {
  UPSERT_CONTRACT(state, item) {
    state.list = [...state.list.filter((entry) => entry.id !== item.id), item];
  },
  UPDATE_CONTRACTS(state, data) {
    state.list = data;
  },
  CONTRACTS_DATA_IS_UPDATED(state, data) {
    state.dataIsUpdated = data;
  },
};

const actions = {
  getContract({ commit }, id) {
    if (contractDetailsInFlight.has(id)) return contractDetailsInFlight.get(id);
    const request = getContract(id).then((response) => {
      if (!response.data.success) throw new Error('Не удалось загрузить запись');
      commit('UPSERT_CONTRACT', response.data.data);
      return response.data.data;
    }).finally(() => contractDetailsInFlight.delete(id));
    contractDetailsInFlight.set(id, request);
    return request;
  },
  // payload.partnerId — партнёр брони: список сужается до его записей и «общих».
  getContracts({ commit }, payload = {}) {
    const partnerId = Number(payload?.partnerId) || null;
    const key = partnerId ?? 'all';

    contractsLatestKey = key;

    if (contractsInFlight.has(key)) return contractsInFlight.get(key);

    const request = getContracts(partnerId ? { partnerId } : {})
      .then((response) => {
        if (key !== contractsLatestKey) return;

        if ('success' in response.data && response.data.success) {
          commit('UPDATE_CONTRACTS', response.data.data);
          commit('privilege/UPDATE_CONTRACT_PRIVILEGE', response.data.privilege, { root: true });
          commit('CONTRACTS_DATA_IS_UPDATED', false);
        }
      })
      .catch(() => {
        if (key !== contractsLatestKey) return;

        commit('privilege/UPDATE_CONTRACT_PRIVILEGE', getDenyPrivilegeObject(), { root: true });
      })
      .finally(() => {
        contractsInFlight.delete(key);
      });

    contractsInFlight.set(key, request);

    return request;
  },

  createContract({ commit }, params) {
    return createContract(params)
      .then((response) => {
        if ('success' in response.data && response.data.success) {
          ElNotification.success({
            message: response.data.message,
            duration: 2000,
          });

          commit('CONTRACTS_DATA_IS_UPDATED', true);

          return response.data.data?.id ?? null;
        }

        return null;
      })
      .catch((error) => {
        ElNotification.error({
          dangerouslyUseHTMLString: true,
          message: getErrorMessage(error?.response?.data),
          duration: 2000,
        });

        return null;
      });
  },

  updateContract({ commit }, { id, data }) {
    return updateContract(id, data)
      .then((response) => {
        if ('success' in response.data && response.data.success) {
          ElNotification.success({
            message: response.data.message,
            duration: 2000,
          });

          commit('CONTRACTS_DATA_IS_UPDATED', true);

          return id;
        }

        return null;
      })
      .catch((error) => {
        ElNotification.error({
          dangerouslyUseHTMLString: true,
          message: getErrorMessage(error?.response?.data),
          duration: 2000,
        });

        return null;
      });
  },

  deleteContract({ commit }, id) {
    deleteContract(id)
      .then((response) => {
        if ('success' in response.data && response.data.success) {
          ElNotification.success({
            message: response.data.message,
            duration: 2000,
          });

          commit('CONTRACTS_DATA_IS_UPDATED', true);
        }
      })
      .catch((error) => {
        ElNotification.error({
          dangerouslyUseHTMLString: true,
          message: getErrorMessage(error?.response?.data),
          duration: 2000,
        });
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
